import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-stats-reports",
  imports: [CommonModule],
  templateUrl: "./stats-reports.component.html",
  styleUrl: "./stats-reports.component.scss",
})
export class StatsReportsComponent implements OnInit {
  ngOnInit(): void {}

  //#region  variables
  //#endregion
}
